import React from 'react'
import PropTypes from 'prop-types'
import Autosuggest from 'react-autosuggest'
import match from 'autosuggest-highlight/match'
import parse from 'autosuggest-highlight/parse'
import { TextField, MenuItem, Paper, IconButton } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import {
  getSuggestionValue,
  getSectionSuggestions,
} from '../../../Utils/GlobalSearch/GlobalSearchUtils'
import SearchIcon from '../../../Assets/Images/icons/globalSearch'
import styles from '../styles'

const renderInputComponent = ({ classes, ...other }) => (
  <TextField
    fullWidth
    InputProps={{
      classes: {
        input: classes.input,
      },
      disableUnderline: true,
    }}
    {...other}
  />
)

const renderSectionTitle = section => {
  return section.results.length ? (
    <div style={{ padding: '12px', fontSize: '14px', color: 'gray' }}>
      {section.title}
    </div>
  ) : null
}

const renderSuggestion = (suggestion, { query, isHighlighted }) => {
  const suggestionLabel = getSuggestionValue(suggestion)
  const matches = match(suggestionLabel, query)
  const parts = parse(suggestionLabel, matches)
  return (
    <MenuItem
      selected={isHighlighted}
      component="div"
      style={{ paddingTop: '0px', paddingBottom: '0px', whiteSpace: 'pre' }}
    >
      {parts.map((part, index) => {
        return part.highlight ? (
          <div
            key={String(index)}
            style={{
              fontSize: '14px',
              fontWeight: 500,
            }}
          >
            {part.text}
          </div>
        ) : (
          <div
            key={String(index)}
            style={{
              fontSize: '14px',
              fontWeight: 300,
            }}
          >
            {part.text}
          </div>
        )
      })}
    </MenuItem>
  )
}

const GlobalSearchView = ({
  classes,
  suggestions,
  onChange,
  onSuggestionSelected,
  handleSuggestionsFetchRequested,
  handleSuggestionsClearRequested,
  inputValue,
  style,
  placeholder,
  showButton,
}) => {
  const autosuggestProps = {
    renderInputComponent,
    suggestions,
    onSuggestionSelected,
    onSuggestionsFetchRequested: handleSuggestionsFetchRequested,
    onSuggestionsClearRequested: handleSuggestionsClearRequested,
    getSuggestionValue,
    renderSuggestion,
    getSectionSuggestions,
    renderSectionTitle,
    multiSection: true,
    alwaysRenderSuggestions: true,
    focusInputOnSuggestionClick: false,
    theme: {
      container: classes.container,
      suggestionsContainerOpen: classes.suggestionsContainerOpen,
      suggestionsList: classes.suggestionsList,
      suggestion: classes.suggestion,
    },
    inputProps: {
      classes,
      placeholder: placeholder || 'Search Anything',
      value: inputValue,
      onChange,
    },
    renderSuggestionsContainer: options => (
      <Paper {...options.containerProps} square>
        {options.children}
      </Paper>
    ),
  }
  return (
    <section className={classes.root} style={style}>
      {showButton && (
        <IconButton
          onClick={handleSuggestionsFetchRequested}
          className={classes.iconButton}
        >
          <SearchIcon onClick={handleSuggestionsFetchRequested} />
        </IconButton>
      )}
      <Autosuggest {...autosuggestProps} />
    </section>
  )
}

GlobalSearchView.propTypes = {
  classes: PropTypes.object.isRequired,
  suggestions: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onSuggestionSelected: PropTypes.func.isRequired,
  handleSuggestionsFetchRequested: PropTypes.func,
  handleSuggestionsClearRequested: PropTypes.func.isRequired,
  inputValue: PropTypes.string.isRequired,
}

export default withStyles(styles)(GlobalSearchView)



// WEBPACK FOOTER //
// ./src/Components/GlobalSearch/component/GlobalSearchView.js